export default "<div class=\"page\">\r\n  <div class=\"grid\">\r\n    <app-access-rights-grid></app-access-rights-grid>\r\n  </div>\r\n</div>\r\n";